export default "<p>\n  list works!\n</p>\n"